<template>
    <div>
        <PullRefresh v-model="isReFresh" @refresh="onRefresh">
            <List
                    style="padding:5px 10px;"
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    loading-text="拼命加载中..."
                    @load="onLoad"
                    :offset="50"
                    :immediate-check="true"
            >
                <PayItem v-for="item in list" :key="item.id" :info="item" @reFresh="onRefresh"/>
            </List>
        </PullRefresh>
    </div>
</template>

<script>
    import {List, PullRefresh} from "vant";
    import PayItem from "../components/PayItem"

    export default {
        components: {
            List, PullRefresh,
            PayItem
        },
        props: ['state'],
        data() {
            return {
                list: [],
                loading: false,
                isReFresh: false,
                finished: false,
                unitId: null
            };
        },
        mounted() {
            this.$initUnit(this,{'unitId': 'id'})
        },
        methods: {
            onLoad(isPullRefresh) {
                const data = {
                    size: 20,unitId:this.unitId,
                    page: this.list.length / 20 + 1
                }
                if (this.state != 'all') data.state = this.state
                this.$http.tokiot.pay.deviceServiceCharge.list(data)
                    .then(ret => {
                        if (ret) {
                            this.list.push(...ret.rows);
                            this.loading = false;
                            if (isPullRefresh) this.isReFresh = false;
                            // 数据全部加载完成
                            if (this.list.length >= ret.total) {
                                this.finished = true;
                            }
                        }
                    })
            },
            onRefresh() {
                this.show = false;
                this.isReFresh = true;
                this.list = [];
                this.onLoad(true);
            },
        }
    }
</script>

<style scoped>

</style>